import React, { useState, useEffect } from "react";
import UserPanel from "../Dashboard/UserPanel";
import {
  Card,
  CardBody,
  Container,
  Row,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import QualityLogs from "./qualityLogs";
import OverView3 from "../Dashboard/Overview3";
import MachineStatus from "./machineDowndTime";
import MachineManualStatus from "./manualMachineDownTime";
import { useMachine } from "../../context/MachineContext";
import UserPanel2 from "../Dashboard/UserPanel2";
import OverView2 from "./OverView2";
import MachineDummyStatus from "./machinedummyStatus";
import MonthlyRequirementForm from "../AdvancedAnalysis/MonthlyRequirementForm";
import MonthlyProductionStatus from "./MonthlyProductionStatus";

const BatchControl = () => {
  const authToken = localStorage.getItem("access");
  const location = useLocation();
  const navigate = useNavigate();
  const machine = location.state?.part;
  // const [selectedChildPart, setSelectedChildPart] = useState("");
  const [machines, setMachines] = useState([]);
  //const { selectedMachineId } = useMachine();
  const selectedMachineId = localStorage.getItem('selectedMachineId');
  const [selectedMachine, setSelectedMachine] = useState(machine?.machine_id || selectedMachineId);
  const [operators, setOperators] = useState([]);
 const selectedCompanyId = localStorage.getItem('companyid');
  useEffect(() => {
    fetchMachine();
  }, []);
  const fetchMachine = async () => {
    try {
      const response = await fetch(`https://api.hanoch.in/api/machines/by-company/?id=${selectedCompanyId}`)
      
      if (response.ok) {
        const machines = await response.json();

        setMachines(machines?.data);
      } else if (response.status === 401) {
        // Unauthorized: Log out the user
        localStorage.removeItem("access");
        // localStorage.removeItem("admin");
      } else {
        console.error("Error fetching data:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const selectedMachineObject = machines.find(m => m.id == selectedMachine);
  const isManual = selectedMachineObject?.manual ?? false;
  const selectedChildPart = selectedMachineObject?.parts;
  const [partsData, setPartsData] = useState({
    good_parts: 1,
    bad_parts: 0,
    total_parts: 0,
    total_running_hours: 0,
    stopped_time: 0,
  });
  const [partsMData, setPartsMData] = useState({
    good_parts: 1,
    bad_parts: 0,
    total_parts: 0,
    total_running_hours: 0,
    machine: "machine name",
    part: "part name",
    part_number: 0,
  });


  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    // console.log( `${year}-${month}-${day}`,'yyyyyyy');
    return `${year}-${month}-${day}`;
  };
  const [selectedDate, setSelectedDate] = useState(() => machine?.date || getTodayDate());


  const isShiftDisabled = (shift) => {
    const now = new Date();
    const currentHour = now.getHours();

    if (shift === "1") {
      return currentHour < 6; // After 2 PM, Shift 1 is over
    } else if (shift === "2") {
      return currentHour < 14; // After 10 PM, Shift 2 is over
    } else if (shift === "3") {
      return currentHour < 22 && currentHour >= 6;
      // Shift 3 (10PM-6AM) is *upcoming* if it's between 6 AM to 10 PM
    }
    return false;
  };

  const getCurrentShift = () => {
    const now = new Date();
    const hours = now.getHours();
    if (hours >= 6 && hours < 14) {
      return 1; // Shift 1: 6am to 2pm
    } else if (hours >= 14 && hours < 22) {
      return 2; // Shift 2: 2pm to 10pm
    } else {
      return 3; // Shift 3: 10pm to 6am
    }
  };
  const [selectedShift, setSelectedShift] = useState(() => machine?.shift || getCurrentShift());

  const fetchPLCData = async (date = selectedDate, shift = selectedShift, selectedMachine) => {
    const response = await fetch(
      `https://api.hanoch.in/api/get-shift-data/?shift=${shift}&date=${date}&machine_id=${selectedMachine}`
    );
    const data = await response.json();
    setPartsData({
      ...partsData,
      bad_parts: data?.bad_products || 0,
      good_parts: data?.good_products || 0,
      stopped_time: data?.stopped_time || 0,
      total_parts: data?.total_count || 0,
      total_running_hours: data?.machine_running_hours || 0,
      machine: data?.machine_name || "machine name",
      part: data?.part || "part name",
      part_number: data?.part_number || 0,
    });
  };
  const fetchPLCDataManual = async (date = selectedDate, shift = selectedShift, selectedMachine) => {
    const response = await fetch(
      `https://api.hanoch.in/api/manual-machine-shift-data/?shift=${shift}&date=${date}&machine_id=${selectedMachine}`
    );
    const data = await response.json();
    setPartsMData({
      ...partsMData,
      bad_parts: data?.bad_products || 0,
      good_parts: data?.good_products || 0,
      total_parts: data?.total_count || 0,
      total_running_hours: data?.machine_running_hours || 0,
      machine: data?.machine_name || "machine name",
      part: data?.part || "part name",
      part_number: data?.part_number || 0,
    });

  };
  useEffect(() => {
    if (selectedDate && selectedShift && selectedMachine) {
      if (isManual === true) {
        fetchPLCDataManual(selectedDate, selectedShift, selectedMachine);
      }
      else {
        fetchPLCData(selectedDate, selectedShift, selectedMachine);
      }
    }
  }, [selectedDate, selectedShift, selectedMachine, isManual]);
  useEffect(() => {
    let intervalId;
    const fetchAndSchedule = async () => {
      if (selectedDate && selectedShift && selectedMachine) {
        await fetchPLCData(selectedDate, selectedShift, selectedMachine);
      }
    };
    fetchAndSchedule();
    intervalId = setInterval(() => {
      const now = new Date();
      const today = now.toISOString().split("T")[0];
      const currentShift = getCurrentShift();

      if (selectedDate === today && Number(selectedShift) === currentShift) {
        fetchAndSchedule();
      }
    }, 60000);

    return () => clearInterval(intervalId);
  }, [selectedDate, selectedShift, selectedMachine]);

  const handleDateChange = (event) => {
    const newDate = event.target.value;
    setSelectedDate(newDate);
  };
  const handleMachineChange = (event) => {
    const machineId = event.target.value;
    setSelectedMachine(machineId);
  };
  const handleShiftChange = (event) => {
    const newShift = event.target.value;
    setSelectedShift(newShift);
  };
  const [partsDataMap, setPartsDataMap] = useState({
    goodPartsList: [],
    badPartsList: [],
    dateTimeList: [],
  });

  document.title = "Batch Control | OptiMize ";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Batch Control" />
          <Card>
            <CardBody className="p-1">
              <div className="d-flex flex-wrap align-items-center mb-3"
                style={{
                  gap: "12px",
                  padding: "12px 16px",
                  // backgroundColor: "#252b3b",
                  color: "#c9d1d9",
                  borderRadius: "6px",
                  width: "100%"
                }}>
                <div className="d-flex align-items-center">
                  <label style={{
                    fontSize: "13px",
                    marginRight: "6px",
                    marginBottom: 0,
                    color: "#8b949e"
                  }}>Select Machine:</label>
                  <select
                    className="form-control"
                    id="machine"
                    name="selectedMachine"
                    value={selectedMachine || ""}
                    onChange={handleMachineChange}
                  >
                    <option key="default">Select Machine</option>
                    {machines?.map((machine, index) => (
                      <option key={index} value={machine.id}>
                        {machine.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div style={{
                  // backgroundColor: "#21262d",
                  padding: "4px 10px",
                  borderRadius: "6px",
                  border: "1px solid #30363d"
                }}>
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>{partsData?.part}</span>
                </div>
                <div className="d-flex align-items-center">
                  <label style={{
                    fontSize: "13px",
                    marginRight: "6px",
                    marginBottom: 0,
                    color: "#8b949e"
                  }}>Shift:</label>
                  <select
                    value={selectedShift}
                    onChange={handleShiftChange}
                    style={{
                      padding: "4px 8px",
                      borderRadius: "6px",
                      fontSize: "13px"
                    }}
                  >
                    <option value="">Select shift</option>
                    <option value="1" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("1")}>6-2 (Shift 1)</option>
                    <option value="2" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("2")}>2-10 (Shift 2)</option>
                    <option value="3" disabled={selectedDate === new Date().toISOString().split('T')[0] && isShiftDisabled("3")}>10-6 (Shift 3)</option>
                  </select>
                </div>

                <div className="d-flex align-items-center">
                  <label style={{
                    fontSize: "13px",
                    marginRight: "6px",
                    marginBottom: 0,
                    color: "#8b949e"
                  }}>Date:</label>
                  <input
                    type="date"
                    value={selectedDate}
                    onChange={handleDateChange}
                    max={new Date().toISOString().split('T')[0]}
                    style={{
                      padding: "4px 8px",
                      color: "#c9d1d9",
                      borderRadius: "6px",
                      fontSize: "13px"
                    }}
                  />
                </div>
              </div>
            </CardBody>
          </Card>

          {isManual ? (
            <UserPanel2 partsData={partsMData}
              selectedChildPart={partsMData.part_number} />
          ) : (
            <UserPanel partsData={partsData}
              selectedChildPart={partsData.part_number} />
          )}
          {isManual ? (
            <OverView2 partsDataMap={partsDataMap}
              selectedDate={selectedDate}
              selectedShift={selectedShift}
              selectedMachine={selectedMachine}
              selectedChildPart={selectedChildPart}

            />
          ) : (
            <OverView3 partsDataMap={partsDataMap}
              selectedDate={selectedDate}
              selectedShift={selectedShift}
              selectedMachine={selectedMachine}
              selectedChildPart={selectedChildPart}

            />
          )}
          {/* <MonthlyRequirementForm/> */}


          <Row>
            {/* <QualityLogs selectedDate={selectedDate}
              selectedMachine={selectedMachine}
              selectedShift={selectedShift}
              selectedChildPart={selectedChildPart}
  isManual={isManual}
            /> */}
            {isManual ? (
              <MachineManualStatus
                selectedDate={selectedDate}
                selectedShift={selectedShift}
                selectedMachine={selectedMachine}
                part={partsData?.part}

              />


            ) : (
              // <MachineStatus selectedDate={selectedDate}
              //             selectedShift={selectedShift}
              //             selectedMachine={selectedMachine}
              //             part={partsData?.part}

              //           />
              <MachineDummyStatus
                selectedDate={selectedDate}
                selectedShift={selectedShift}
                selectedMachine={selectedMachine}
                part={partsData?.part}
              />
            )}

          </Row>

          {/* <Row> */}
          {/* Order Stats */}
          {/* <OrderStatus /> */}
          {/* Notifications */}
          {/* <Notifications /> */}
          {/* Revenue by Location Vector Map */}
          {/* <RevenueByLocation /> */}
          {/* </Row> */}

          {/* Latest Transaction Table */}
          {/* <LatestTransation /> */}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BatchControl;
